import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import {useNotification} from 'config/Notification';

import { forgotPasswordRequestService } from 'services/modules/idp/auth';

import {setErrors} from 'stores/modules/idp/authreducer';

import {Button, OutlinedInput} from '@mui/material';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function RequestForgotPassword() {
  // State variables
  const [formData, setFormData] = useState({ email: '' });
  const [errorMessage, setErrorMessage] = useState(null);
  const [emailError, setEmailError] = useState('');

  // Redux selectors
  const forgotPasswordRequestStatusContainer = useSelector(state => state.auth.forgotPasswordRequestStatus);
  const getErrorsContainer = useSelector(state => state.auth.errors);

  // React Router
  const Navigate = useNavigate();

  // Redux dispatch
  const dispatch = useDispatch();

  // Notification 
  const { openNotification } = useNotification();

  // Handles the changes of email field
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (!e.target.value.trim()) {
      setEmailError('Email is required');
    } else {
      setEmailError('');
    }
  };

  // This method set the errors and redirect back to login
  const handleBack = () => {
    const empty = null;
    dispatch(setErrors(null));
    setErrorMessage(empty);
    Navigate('/');
  }
  
  // Handles the form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email.trim()) {
      setEmailError('Email is required');
    } else {
      dispatch(forgotPasswordRequestService(formData));
    }
  };

  // useEffect hook to handle requestforgotpassword  and redirection to forgot password verification
  useEffect(() => {
    if (forgotPasswordRequestStatusContainer === true) {
      setErrorMessage('');
      openNotification("OTP sent to registered email" , "success")
      Navigate("/forgot-password-verification");
    }  
    if (getErrorsContainer && getErrorsContainer.data) {
      setErrorMessage(getErrorsContainer.data.message);
      openNotification(errorMessage , "error")
    }
    else if (forgotPasswordRequestStatusContainer === false && getErrorsContainer && getErrorsContainer.data) {
      setErrorMessage(getErrorsContainer.data.message);
      openNotification(errorMessage , "error")
    }
       // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forgotPasswordRequestStatusContainer, getErrorsContainer, errorMessage]);
  

  return (
    <div className='bg-Container'>
      <div className='col-xl-8 col-lg-8 col-md-8 col-sm-10 col-xs-12'>
        <div className="Card">

          <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <img src="../assets/rhymtech_logo_2.png" alt="RhymLogo" className='Rhym-logo' />
            <div className="heading-container">
              <h4 className='headingtext-login'>RHYM Security Platform</h4>
            </div>
            <img src="../assets/6538623.5a47e6cc.jpg" alt="text" className="bg-logo" />
          </div>

          <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <div className='Card-Container'>
              <div className='forgotpassword-card'>
                <img src="../assets/loginuser.svg" alt="UserIcon" className="user-icon" />
                <h4 className="pageHeading">Forgot Password</h4>
                <form onSubmit={handleSubmit}>
                  <OutlinedInput
                    className= {emailError ? 'err-label' : 'noerr-label'}
                    placeholder= {emailError ? 'Email is required' : 'Email'}
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    onBlur={handleChange}
                    required
                    error={Boolean(emailError)}
                    endAdornment={emailError && (<ErrorOutlineIcon className='erroutline-icon' /> )}
                  /> 
                  <br/>
                  <Button className="submit-button" onClick={handleSubmit} type="submit" variant="contained"> Request Update Password </Button>
                </form>

                <div className='text-container'>
                  {/* <Link  onClick={handleBack} className='forgottext' >Back to login</Link> */}
                  <a onClick={handleBack} href className='forgottext' >Back to login</a>
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RequestForgotPassword;
